import { render } from "./memory-resource-monitoring.vue?vue&type=template&id=f46215ae&scoped=true"
import script from "./memory-resource-monitoring.vue?vue&type=script&lang=js"
export * from "./memory-resource-monitoring.vue?vue&type=script&lang=js"

import "./memory-resource-monitoring.vue?vue&type=style&index=0&id=f46215ae&scoped=true&lang=css"
import "./memory-resource-monitoring.vue?vue&type=style&index=1&id=f46215ae&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f46215ae"]])

export default __exports__